export default {
  "site_name": "麻豆传媒app官网",
  "site_description": "麻豆传媒app官方下载与使用指南",
  "nav_home": "首页",
  "nav_download": "下载指南",
  "nav_install": "安装教程",
  "nav_guide": "使用指南",
  "nav_updates": "最新动态",
  "nav_faq": "常见问题",
  "nav_about": "关于我们",
  "hero_title": "麻豆传媒app",
  "hero_subtitle": "畅享丰富内容体验，安全便捷的移动娱乐平台",
  "hero_cta": "查看下载指南",
  "hero_secondary": "了解更多",
  "category_title": "分类浏览",
  "category_subtitle": "选择您感兴趣的内容分类，快速找到所需信息",
  "featured_articles": "精选文章",
  "featured_subtitle": "最受欢迎的教程与指南，助您快速上手",
  "download_cta_title": "准备好开始了吗？",
  "download_cta_subtitle": "立即下载麻豆传媒app，开启您的精彩内容之旅",
  "download_cta_button": "前往下载页面",
  "footer_brand": "麻豆传媒",
  "footer_copyright": "版权所有",
  "footer_rights": "保留所有权利",
  "breadcrumb_home": "首页",
  "read_more": "阅读全文",
  "related_articles": "相关文章",
  "share_article": "分享文章",
  "back_to_home": "返回首页",
  "about_title": "关于我们",
  "about_brand_title": "品牌介绍",
  "about_reputation_title": "用户口碑",
  "about_contact_title": "联系我们",
  "page_not_found": "页面未找到",
  "page_not_found_desc": "抱歉，您访问的页面不存在或已被移动",
  "article_author": "作者",
  "article_date": "发布日期",
  "article_views": "阅读量",
  "article_category": "分类",
}